import { ExamStepDetailPage } from "@/features/exam-steps/pages/ExamStepDetail";

export default ExamStepDetailPage;
